export default {
  methods: {
    bindMove: function (elem, fn, bool) {
      var _this = this

      elem.addEventListener('mousedown', function (e) {
        // 非左键点击不能拖拽滚动
        if (e.which !== 1) {
          return false
        }
        _this.downX = e.pageX
        _this.downY = e.pageY
        bool ? fn.call(_this, _this.downX, _this.downY) : fn.call(_this, elem, _this.downX, _this.downY)

        document.addEventListener('mousemove', mousemove, false)
        function mousemove(e) {
          _this.moveX = e.pageX
          _this.moveY = e.pageY
          bool ? fn.call(_this, _this.moveX, _this.moveY) : fn.call(_this, elem, _this.moveX, _this.moveY)
          e.preventDefault()
        }
        document.addEventListener('mouseup', mouseup, false)
        function mouseup(e) {
          document.removeEventListener('mousemove', mousemove, false)
          document.removeEventListener('mouseup', mouseup, false)
        }
      }, false)
    },
    hsbToRgb: function (hsb) {
      var rgb = {}
      var h = Math.round(hsb.h)
      var s = Math.round(hsb.s * 255 / 100)
      var v = Math.round(hsb.b * 255 / 100)

      if (s === 0) {
        rgb.r = rgb.g = rgb.b = v
      } else {
        var t1 = v
        var t2 = (255 - s) * v / 255
        var t3 = (t1 - t2) * (h % 60) / 60

        if (h === 360) h = 0

        if (h < 60) { rgb.r = t1; rgb.b = t2; rgb.g = t2 + t3 } else if (h < 120) { rgb.g = t1; rgb.b = t2; rgb.r = t1 - t3 } else if (h < 180) { rgb.g = t1; rgb.r = t2; rgb.b = t2 + t3 } else if (h < 240) { rgb.b = t1; rgb.r = t2; rgb.g = t1 - t3 } else if (h < 300) { rgb.b = t1; rgb.g = t2; rgb.r = t2 + t3 } else if (h < 360) { rgb.r = t1; rgb.g = t2; rgb.b = t1 - t3 } else { rgb.r = 0; rgb.g = 0; rgb.b = 0 }
      }

      return { r: Math.round(rgb.r), g: Math.round(rgb.g), b: Math.round(rgb.b) }
    },
    hexOpacityToA(hex) {
      if (hex.length !== 9) {
        return 1
      }
      let transparencyList = [
        '00',
        '0D',
        '1A',
        '26',
        '33',
        '40',
        '4D',
        '59',
        '66',
        '73',
        '80',
        '8C',
        '99',
        'A6',
        'B3',
        'BF',
        'CC',
        'D9',
        'E6',
        'F2',
        'FF'
      ]

      return transparencyList.indexOf(hex.slice(7, 9)) * 5 / 100
    },
    rgbToHex: function (rgba) {
      let hex = [
        parseInt(rgba.r).toString(16),
        parseInt(rgba.g).toString(16),
        parseInt(rgba.b).toString(16)
      ]

      hex.map(function (str, i) {
        if (str.length === 1) {
          hex[i] = '0' + str
        }
      })

      // if (rgba.a !== 1) {
      //   let opacity = rgba.a * 100
      //   let transparency
      //   let transparencyList = [
      //     '00',
      //     '0D',
      //     '1A',
      //     '26',
      //     '33',
      //     '40',
      //     '4D',
      //     '59',
      //     '66',
      //     '73',
      //     '80',
      //     '8C',
      //     '99',
      //     'A6',
      //     'B3',
      //     'BF',
      //     'CC',
      //     'D9',
      //     'E6',
      //     'F2'
      //   ]
      //   if (opacity < 10) {
      //     if (opacity < 3) {
      //       transparency = transparencyList[0]
      //     } else if (opacity > 2 && opacity < 7) {
      //       transparency = transparencyList[1]
      //     } else {
      //       transparency = transparencyList[2]
      //     }
      //   } else if (opacity > 95 && opacity < 100) {
      //     transparency = transparencyList[19]
      //   } else {
      //     let obj = `${opacity}`.split('')
      //     let singleDigits = parseInt(obj[1])
      //     let singleDigitsStrying = obj[1]
      //     if (singleDigits < 3) {
      //       singleDigitsStrying = '0'
      //     } else if (singleDigits > 2 && singleDigits < 7) {
      //       singleDigitsStrying = '5'
      //     } else {
      //       obj[0] = parseInt(obj[0]) + 1
      //       singleDigitsStrying = '0'
      //     }

      //     let index = parseInt(obj[0] + singleDigitsStrying) / 5

      //     transparency = index > transparencyList.length ? transparencyList[19] : transparencyList[index]
      //   }
      //   hex.push(transparency)
      // }

      return hex.join('')
    },
    hexToRgb: function (hex) {
      let opacity = 1
      if (hex.length === 9) {
        opacity = this.hexOpacityToA(hex)
        hex = hex.slice(0, 7)
      }
      var newHex = parseInt(((hex.indexOf('#') > -1) ? hex.substring(1) : hex), 16)
      return { r: newHex >> 16, g: (newHex & 0x00FF00) >> 8, b: (newHex & 0x0000FF), a: opacity }
    },
    rgbToHsb: function (rgb) {
      var hsb = { h: 0, s: 0, b: 0 }
      var min = Math.min(rgb.r, rgb.g, rgb.b)
      var max = Math.max(rgb.r, rgb.g, rgb.b)
      var delta = max - min
      hsb.b = max
      hsb.s = max !== 0 ? 255 * delta / max : 0
      if (hsb.s !== 0) {
        if (rgb.r === max) hsb.h = (rgb.g - rgb.b) / delta
        else if (rgb.g === max) hsb.h = 2 + (rgb.b - rgb.r) / delta
        else hsb.h = 4 + (rgb.r - rgb.g) / delta
      } else hsb.h = -1
      hsb.h *= 60
      if (hsb.h < 0) hsb.h += 360
      hsb.s *= 100 / 255
      hsb.b *= 100 / 255
      return hsb
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/color-picker/util.js